import request from "../utils/request";

export function GET_DashboardOverview(token) {
  return request.get("/Dashboard/Overview", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_DashboardOverdueTasks(token) {
  return request.get("/Dashboard/OverdueTasks", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_DashboardMyTasks(token) {
  return request.get("/Dashboard/MyTasks", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_DashboardActivities(token, payload) {
  return request.get("/Dashboard/Activities", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_DashboardProjectOverview(token, params) {
  return request.get("/Dashboard/ProjectOverview", params, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
